import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function PageNavigation() {
    const location = useLocation();
    const isLocationMatch = location.pathname.includes(
        'settings/notifications',
    );

    return (
        <ul className="navigation-tabs__list">
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="general"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    General
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="api-keys"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    API keys
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="notifications/defaults"
                    className={({ isActive }) =>
                        isActive || isLocationMatch
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Notifications
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="terms-of-use"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Terms of Use
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="privacy-policy"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Privacy Policy
                </NavLink>
            </li>
        </ul>
    );
}
